
export const config = {
  test: 'https://smartsearch-apitest.roche.com.cn',
  dev: 'http://192.168.212.37:8008',
  pro: 'https://smart-search-api.roche.com.cn'
  // pro: 'https://smartsearch-test-api.roche-digital.cn'
  // pro: 'https://smart-search-api.roche-digital.cn'
}